import Vue from "vue";
import store from "../store";
// 全部公共函数配置
Vue.prototype.$fn = {
  // 手机号正则
  phonereg(phone) {
    let phonereg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return phonereg.test(parseInt(phone));
  },

  isLogin() {
    return this.getUserData() && this.getUserData().mobile && this.ifreg();
  },

  // 用户是否注册过 以及确定注册过
  ifreg() {
    let userdata = this.getUserData();
    if (!userdata || userdata == null) {
      return false;
    }
    if (userdata.authFlag == 0) {
      // 没有注册
      return false;
    } else if (userdata.authFlag != 0 && userdata.authSrc != 0) {
      // 没有注册 但是后台有提前录入
      return false;
    } else {
      // 已经确定注册过了
      return true;
    }
  },
  // 获取用户缓存
  getUserData() {

    return store.getters.getUserData || null;
  },
  //用户数据缓存
  setUserData(userdata) {
    store.commit("setUserData", userdata);
  },

  //退出登陆
  quit() {
    store.commit("setCartNum", 0);
    store.commit("setUserData", null);
  },

  //刷新用户数据
  run(fn) {
    Vue.prototype.$ajax("/iap-api/wan4/base/myLoginInfo.do", {}).then((res) => {
      this.setUserData(res.data);
      fn && fn();
    });
  },

  //金额格式 num: 金额， type 0: 整数部分，1:小数部分
  initPrice(num, type) {
    num = num || 0;
    let str = (num / 100).toString();
    if (type == 0) {
      if (str.indexOf(".") != -1) {
        str = str.slice(0, str.indexOf("."));
      }
    } else {
      if (str.indexOf(".") != -1) {
        str = str.slice(str.indexOf("."));
        str.length == 2 ? (str = str + "0") : "";
      } else {
        str = ".00";
      }
    }
    if (parseInt(str) > 1000) {
      str = parseInt(str).toLocaleString();
    }
    return str;
  },

  px2rem(px) {
    return (window.innerWidth / 750) * px;
  },

  sliceJz(str) {
    if (str.indexOf("-∅") == -1) {
      return str;
    } else {
      return str.slice(0, str.indexOf("-∅"));
    }
  },
};
